import { render, staticRenderFns } from "./ApproveDevice.vue?vue&type=template&id=8dc45fca&scoped=true&"
import script from "./ApproveDevice.vue?vue&type=script&lang=js&"
export * from "./ApproveDevice.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDevice.vue?vue&type=style&index=0&id=8dc45fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc45fca",
  null
  
)

export default component.exports